import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Card, space } from '@ticketswap/solar'
import PricePerTicket from '../PricePerTicket'
import { useViewer } from '../ViewerContext'
import { track } from '~/utils'
import AuthDialog from '../AuthDialog'
import { decodeGlobalId } from '~/utils/id'
import { LISTING_CLICKED, AUTHENTICATION_VIEWED } from '~/lib/tracking-events'
import visit from '~/utils/visit'
import ListingAvatar from '~/components/ListingAvatar'
import ListingAvatarBadge from '~/components/ListingAvatarBadge'

const StyledCard = styled(Card)`
  margin: ${space[8]} 0;
  cursor: pointer;
`

const AvatarContainer = styled.div`
  position: relative;
`

function OrganizerOffering({ t, event, eventType, url, ...props }) {
  const { viewer } = useViewer()
  const organizer = {
    name: event?.organizerShop?.organizerBranding?.name,
    image: event?.organizerShop?.organizerBranding?.image || event?.imageSmallUrl,
    itemPrice: eventType?.organizerProduct?.displayPrice,
  }

  const handleOnClick = () => {
    if (typeof url === 'object') {
      visit(url)

      track(LISTING_CLICKED, {
        ticketType: 'organizer',
        userID: viewer ? decodeGlobalId(viewer.id) : null,
        eventId: decodeGlobalId(event.id),
        eventName: event.name,
        eventTypeId: eventType ? decodeGlobalId(eventType.id) : undefined,
        eventTypeName: eventType?.title,
        displayPrice: organizer.itemPrice,
      })
    } else {
      window.location.href = url
    }
  }

  return (
    <AuthDialog onToggle={on => on && track(AUTHENTICATION_VIEWED)} onComplete={handleOnClick}>
      {({ show }) => (
        <a
          onClick={() => {
            if (!viewer) {
              return show()
            }

            handleOnClick()
          }}
          {...props}
        >
          <StyledCard
            size="large"
            verticalAlign="top"
            title={
              event?.organizerShop
                ? eventType?.title || t('event-eventtype:organizerOffering.allTypes')
                : t('event-eventtype:organizerOffering.ticketShop')
            }
            text={event?.name}
            leftAdornment={
              organizer.name ? (
                <AvatarContainer>
                  <ListingAvatar image={organizer.image} />
                  <ListingAvatarBadge />
                </AvatarContainer>
              ) : (
                <ListingAvatar image={organizer.image} />
              )
            }
            rightAdornment={
              organizer.itemPrice ? <PricePerTicket t={t} price={organizer.itemPrice} /> : null
            }
          />
        </a>
      )}
    </AuthDialog>
  )
}

OrganizerOffering.propTypes = {
  t: PropTypes.func.isRequired,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    organizerShop: PropTypes.shape({
      id: PropTypes.string.isRequired,
      organizerBranding: PropTypes.object,
      hasDynamicProducts: PropTypes.bool.isRequired,
    }),
  }),
  eventType: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  displayPrice: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
  }),
}

export default OrganizerOffering
